import React from 'react';

import { PrimaryFilters as PrimaryFiltersProvider } from 'components/Filters';

import * as Filters from './filters';

const PrimaryFilters = () => (
  <PrimaryFiltersProvider>
    <Filters.BusinessPartners />
    <Filters.Show />
  </PrimaryFiltersProvider>
);

export default PrimaryFilters;
